import React, { useState } from "react";
import { getWfPhasesColor } from "../../services/appService";
import Moment from "react-moment";
import TaskHistory from "../../components/TaskHistory";
import TaskReAssignPopup from "../../components/TaskReAssignPopup";

export default function TaskInfo(props) {
    const { wfTask, app, handleReAssignSubmit, handleShowHideSection, handleWorkflowModalShowHide, workflowLabel } = props;

    const [historyAppShowHide, setHistoryAppShowHide] = useState(false);
    const [reAssignShowHide, setReAssignShowHide] = useState(false);
    const [showTaskInfoBody, setShowTaskInfoBody] = useState(true);

    const phaseClass = getWfPhasesColor(wfTask?.wfPhase);
    const isDone = Boolean(wfTask?.status || wfTask?.taskDoneStatus === 4);
    const phaseLabel = wfTask?.wfPhase === "Application" ? "Review" : wfTask?.wfPhase || "Task";
    const taskName = wfTask?.itemName || wfTask?.taskName || "Workflow Task";
    const assigneeName = String(wfTask?.performerName || "Unassigned");
    const assigneeInitial = assigneeName.trim().charAt(0).toUpperCase() || "?";
    const workflowText = workflowLabel || (app?.workflowId ? `Workflow #${app.workflowId}` : "Workflow Map");
    const taskReference = wfTask?.wiid ? `Task #${wfTask.wiid}` : app?.ciid ? `Application #${app.ciid}` : "Task";

    const handlehistoryAppModalShowHide = () => {
        if (!historyAppShowHide) setReAssignShowHide(false);
        setHistoryAppShowHide(!historyAppShowHide);
        handleShowHideSection(!historyAppShowHide);
    };

    const handleReAssignModalShowHide = () => {
        if (!reAssignShowHide) setHistoryAppShowHide(false);
        setReAssignShowHide(!reAssignShowHide);
        handleShowHideSection(!reAssignShowHide);
    };

    return (
        <React.Fragment>
            <div className={`rt-task-info-card ${phaseClass}`}>
                <style>{`
                    .rt-task-info-label {
                        font-weight: 600 !important;
                    }

                    .rt-task-status-badge {
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        padding: 5px 16px !important;
                        border-radius: 9999px !important;
                        font-size: 12px !important;
                        font-weight: 600 !important;
                        text-transform: uppercase !important;
                        letter-spacing: 0.03em !important;
                        border: none !important;
                        white-space: nowrap !important;
                        box-shadow: none !important;
                    }

                    .rt-task-status-badge.is-in-progress,
                    .rt-task-status-badge:not(.is-done) {
                        background-color: #ffd600 !important;
                        color: #0f172a !important;
                    }

                    .rt-task-status-badge.is-done {
                        background-color: #2dce89 !important;
                        color: #ffffff !important;
                    }
                `}</style>
                <div className="rt-task-info-top">
                    <div className="rt-task-info-heading">
                        <div className="rt-task-info-icon">
                            <i className="fa fa-tasks" aria-hidden="true" />
                        </div>
                        <div className="rt-task-info-title-wrap">
                            <h3 className="rt-task-info-title" style={{ margin: 0, fontWeight: 600 }}>{taskName}</h3>
                            <div className="rt-task-info-kicker" style={{ marginTop: "3px" }}>
                                <span>{taskReference}</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                        <div className="rt-task-info-action-list" style={{ display: "flex", gap: "8px" }}>
                            {wfTask?.wfPhase !== "Application" && (
                                <button
                                    type="button"
                                    className="rt-action-btn"
                                    onClick={() => handleReAssignModalShowHide(wfTask)}
                                    title="Re-assign Task"
                                >
                                    <i className="fa fa-user-plus" aria-hidden="true" />
                                    Re-Assign
                                </button>
                            )}
                            <button
                                type="button"
                                className="rt-action-btn"
                                onClick={() => handlehistoryAppModalShowHide(wfTask)}
                                title="View Task History"
                            >
                                <i className="fa fa-history" aria-hidden="true" />
                                History
                            </button>
                            <button
                                type="button"
                                className="rt-action-btn"
                                onClick={() => setShowTaskInfoBody(!showTaskInfoBody)}
                                title={showTaskInfoBody ? "Hide Task" : "Show Task"}
                            >
                                <i className={`fa ${showTaskInfoBody ? "fa-eye-slash" : "fa-eye"}`} aria-hidden="true" />
                                {showTaskInfoBody ? "Hide Task" : "Show Task"}
                            </button>
                        </div>
                    </div>
                </div>

                {showTaskInfoBody && (
                    <div className="rt-task-info-body" style={{ gridTemplateColumns: "1fr" }}>
                        <div className="rt-task-info-grid">
                            <div className="rt-task-info-item">
                                <span className="rt-task-info-label">
                                    <i className="fa fa-calendar-plus-o" aria-hidden="true" /> Start Time
                                </span>
                                <span className="rt-task-info-val">
                                    {wfTask?.startDate ? (
                                        <Moment format="MMM Do YYYY, h:mm a">
                                            {wfTask.startDate}
                                        </Moment>
                                    ) : (
                                        <span className="rt-task-muted">Not set</span>
                                    )}
                                </span>
                            </div>

                            <div className="rt-task-info-item">
                                <span className="rt-task-info-label">
                                    <i className="fa fa-calendar-check-o" aria-hidden="true" /> End Time
                                </span>
                                <span className="rt-task-info-val">
                                    {wfTask?.endDate ? (
                                        <Moment format="MMM Do YYYY, h:mm a">
                                            {wfTask.endDate}
                                        </Moment>
                                    ) : (
                                        <span className="rt-task-muted">In Progress</span>
                                    )}
                                </span>
                            </div>

                            <div className="rt-task-info-item">
                                <span className="rt-task-info-label">
                                    <i className="fa fa-user-circle-o" aria-hidden="true" /> Assigned To
                                </span>
                                <span className="rt-task-assignee">
                                    <span className="rt-task-assignee-avatar">{assigneeInitial}</span>
                                    <span className="rt-task-info-val">{assigneeName}</span>
                                </span>
                            </div>

                            <div className="rt-task-info-item">
                                <span className="rt-task-info-label">
                                    <i className="fa fa-tag" aria-hidden="true" /> Phase
                                </span>
                                <span className="rt-task-info-val">{phaseLabel}</span>
                            </div>

                            <div className="rt-task-info-item">
                                <span className="rt-task-info-label">
                                    Task Status
                                </span>
                                <span className="rt-task-info-val" style={{ display: "inline-flex", alignItems: "center", marginTop: "2px" }}>
                                    <span className={`rt-task-status-badge ${phaseClass} ${isDone ? "is-done" : "is-in-progress"}`}>
                                        {isDone ? "DONE" : "IN PROGRESS"}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {historyAppShowHide && (
                <TaskHistory
                    historyAppShowHide={historyAppShowHide}
                    handlehistoryAppModalShowHide={handlehistoryAppModalShowHide}
                    selectedObj={wfTask}
                    doneTasks={app?.workflowTasks || []}
                    taskPhases={app?.allWfPhase || []}
                />
            )}
            {reAssignShowHide && (
                <TaskReAssignPopup
                    reAssignShowHide={reAssignShowHide}
                    handleReAssignModalShowHide={handleReAssignModalShowHide}
                    selectedObj={wfTask}
                    handleReAssignSubmit={handleReAssignSubmit}
                />
            )}
        </React.Fragment>
    );
}
